// extracted by mini-css-extract-plugin
export default {"form":"contactForm_form__BH22f","formInput":"contactForm_formInput__PP+Pp","formTextArea":"contactForm_formTextArea__VkzCQ","formSubmit":"contactForm_formSubmit__U6hzr"};